// Imports in this file have to relative because import aliases are not supported in Nuxt server

import ServiceBase from '@ekd/portal-connector/dist/Service';

import { getEnv } from '../utils/getEnv';

import { ApiUrls } from '../types/apiUrls';
export default class BaseService extends ServiceBase<ApiUrls> {
  constructor(variables?: { req?: PortalRootIncomingMessage }) {
    super(variables);
    const urls: Record<ApiUrls, string> = {
      'config-api': getEnv('configApi'),
      'feed-api': getEnv('feedApi'),
      'content-api-v3': getEnv('contentApiV3').concat('/graphql'),
      'paywall-api': getEnv('paywallApi').concat('/graphql'),
      'customer-data-api': getEnv('customerDataApi').concat('/graphql'),
      'media-api': getEnv('mediaApi').concat('/graphql'),
      'article-extra-content-api': getEnv('articleExtraContentApi'),
      'orders-api': getEnv('ordersApi'),
      'weather-api': getEnv('weatherApi'),
    };

    this.setApiUrls(urls);
  }
}
